class FooterDropdown extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.content = this.querySelector('.footer-details-content');

    if (!this.button || !this.content) return;

    // Only panels that start inert (old footer's mobile-only accordion) toggle it.
    // The dark footer reuses one panel for the desktop columns, so inert there would block desktop links.
    this.togglesInert = this.content.hasAttribute('inert');

    this.button.setAttribute('aria-expanded', 'false');
    this.button.addEventListener('click', this.handler.bind(this));
  }

  handler() {
    const isOpen = this.button.classList.toggle('active');
    this.button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (this.togglesInert) this.content.inert = !isOpen;

    if (isOpen) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
    } else {
      this.content.style.maxHeight = null;
    }
  }
}

if (!customElements.get('footer-dropdown')) {
  customElements.define('footer-dropdown', FooterDropdown);
}

class OrbeCountrySelector extends HTMLElement {
  connectedCallback() {
    // Render outside the cached footer, then take ownership of its localization slot.
    const mount = this.closest('.shopify-section')?.querySelector('.footer-localization-wrapper');
    if (!mount) return;
    if (this.parentElement !== mount) {
      mount.replaceChildren(this);
      return;
    }
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.open);
    this.hidden = false;
    this.observer = new IntersectionObserver(
      (entries) => {
        clearTimeout(this.timer);
        if (entries.some((entry) => entry.isIntersecting)) {
          this.checkReady();
        }
      },
      { rootMargin: '200px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    clearTimeout(this.timer);
    if (this.button) {
      this.button.disabled = true;
      this.button.removeEventListener('click', this.open);
    }
  }

  checkReady = () => {
    // Orbe uses a global lexical binding, with no documented readiness event.
    if (typeof orbito !== 'undefined' && typeof orbito.openModalWithoutRefresh === 'function') {
      this.button.disabled = false;
      this.observer.disconnect();
    } else {
      this.timer = setTimeout(this.checkReady, 250);
    }
  };

  open = () => {
    orbito.openModalWithoutRefresh();
  };
}

if (!customElements.get('orbe-country-selector')) {
  customElements.define('orbe-country-selector', OrbeCountrySelector);
}
